<template>
  <div class="home_con">
    <div style="width: 12.74rem">
      <div class="home_tree">
        <!-- 成长树 -->
        <Card style="width: 3.4rem" dis-hover v-if="organizationId !== '-1'">
          <div ref="tree" style="width: 100%; height: 100%">
            <img src="../../assets/tree.png" class="apple_tree" />
            <ul class="trees">
              <li v-for="(item, i) in appleTreeList" :key="i" :class="appleTreeList.length - i - 1 === index ? 'litlleTree' : ''" @click="toggleTree(appleTreeList.length - i - 1)">
                <img src="../../assets/sm_tree.png" class="sm_tree" :title="item.className" />
              </li>
            </ul>
            <img src="../../assets/apple1.png" ref="apple1" alt="" style="opacity: 0" />
            <img src="../../assets/apple2.png" ref="apple2" alt="" style="opacity: 0" />
            <img src="../../assets/apple3.png" ref="apple3" alt="" style="opacity: 0" />
            <img src="../../assets/apple4.png" ref="apple4" alt="" style="opacity: 0" />
            <img src="../../assets/apple5.png" ref="apple5" alt="" style="opacity: 0" />

            <div class="tree_tip">
              <div class="_boder"></div>
              <span>成长树</span>
              <img src="../../assets/q_mark.png" class="q_mark" @click="showDescription" />
            </div>
            <!-- 雷达图 -->
            <!-- <div class="radar" @click="toViewRadar"> -->
            <div class="radar" v-if="isShowCourseRadar && radarMapList.length">
              <div id="container" style="height: 100%"></div>
            </div>
          </div>
        </Card>
        <!-- 各个班级排行榜 -->
        <div v-if="organizationId !== '-1'">
          <Card dis-hover class="ranking" v-if="countTopList.length">
            <!-- <Carousel v-model="ranking_idx" arrow="never" trigger="hover" autoplay :autoplay-speed="3000">
            <CarouselItem v-for="(item, i) in countTopList" :key="i"> -->
            <div v-for="(item, i) in countTopList" :key="i">
              <div class="ranking_tit">{{ item.topTime }}</div>
              <div class="dis_line">
                <p></p>
              </div>
              <ul v-if="item.content.length">
                <li v-for="(subItem, i2) in item.content" :key="i2">
                  <div v-if="subItem.ranking === 1"><img src="../../assets/gold.png" class="sort_idx" /></div>
                  <div v-else-if="subItem.ranking === 2"><img src="../../assets/silver.png" class="sort_idx" /></div>
                  <div v-else-if="subItem.ranking === 3"><img src="../../assets/bronze.png" class="sort_idx" /></div>
                  <div class="sort_idx" v-else>
                    <span>{{ subItem.ranking }}</span>
                  </div>
                  <div class="s_avatar"><img :src="subItem.studentAvatar" /></div>
                  <p class="author_name">{{ subItem.studentName }}</p>
                  <div class="works_num">{{ subItem.opusCount ? subItem.opusCount : '0' }}件作品</div>
                  <img v-if="subItem.trend === '1'" src="../../assets/up.png" class="trend" />
                  <img v-else-if="subItem.trend === '2'" src="../../assets/down.png" class="trend" />
                  <span v-else></span>
                </li>
              </ul>
              <div class="tips" v-else>暂无上榜作品~</div>
            </div>
            <!-- </CarouselItem>
          </Carousel> -->
          </Card>

          <Card dis-hover class="ranking" v-else>
            <div style="width: 100%; height: 100%; text-align: center; margin-top: 1.2rem">暂无排行榜信息~</div>
          </Card>
        </div>
        <div v-else style="width: 6.2rem; height: 3rem; margin-right: 0.2rem">
          <Carousel dots="none" arrow="never" autoplay :autoplay-speed="3000" style="width: 100%; height: 100%" v-if="adYoukeList.length">
            <Carousel-item v-for="(item, i) in adYoukeList" :key="i">
              <img :src="item.bannerCover" alt="" @click="toAdDetail(item)" style="width: 100%; height: 3rem; border-radius: 0.12rem; display: block; cursor: pointer" />
            </Carousel-item>
          </Carousel>
        </div>
        <!-- 我的成就 -->
        <div class="success" style="width: 6.1rem">
          <Card class="my_grow">
            <h3>我的成就</h3>
            <div class="my_grow_count">
              <div @click="toMyOpusPage">
                作品<span>{{ myAchievements.myOpusCount ? myAchievements.myOpusCount : '0' }}</span
                >件
              </div>
              <div class="my_grow_line"></div>
              <div>
                上榜<span>{{ myAchievements.myTopCount ? myAchievements.myTopCount : '0' }}</span
                >次
              </div>
            </div>
            <!-- <div class="my_grow_info">打败了全网{{ myAchievements.beatProportion ? pct : '0' }}%的同学,继续努力哦!</div> -->
          </Card>
          <div class="my_works">
              <div @click="showScratchType()">
                <Card class="a">
                  <span class="scratch">图形化创作</span>
                  <img src="../../assets/scratch.png" alt="" class="my_works_l" />
                </Card>
              </div>
            <router-link :to="{ path: '../peixun/showPython' }" target="_blank">
              <Card class="a">
                <span class="python">Python创作</span>
                <img src="../../assets/python.png" alt="" class="my_works_r" />
              </Card>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 我的课程 -->
      <Carousel arrow="always" dots="none" style="margin: 0.3rem 0" v-if="newCourseList.length">
        <Carousel-item v-for="(item, i) in newCourseList" :key="i" class="lunbo">
          <div class="course" @click="toLastCourseDetail(item[0])" v-if="item[0]">
            <img src="../../assets/defaultCourseCover.png" />
            <p>上节课程名称：{{ item[0].lastCourseTeachingPlan ? item[0].lastCourseTeachingPlan.courseDetailName : '无' }}</p>
          </div>
          <div class="course" @click="toNextCourseDetail(item[0])" v-if="item[0]">
            <img src="../../assets/defaultCourseCover.png" />
            <p>下节课程名称：{{ item[0].nextCourseTeachingPlan ? item[0].nextCourseTeachingPlan.courseDetailName : '无' }}</p>
          </div>
          <div class="course" @click="toLastCourseDetail(item[1])" v-if="item[1]">
            <img src="../../assets/defaultCourseCover.png" />
            <p>上节课程名称：{{ item[1] && item[1].lastCourseTeachingPlan ? item[1].lastCourseTeachingPlan.courseDetailName : '无' }}</p>
          </div>
          <div class="course" @click="toNextCourseDetail(item[1])" v-if="item[1]">
            <img src="../../assets/defaultCourseCover.png" />
            <p>下节课程名称：{{ item[1] && item[1].nextCourseTeachingPlan ? item[1].nextCourseTeachingPlan.courseDetailName : '无' }}</p>
          </div>
        </Carousel-item>
      </Carousel>

      <!-- 横断广告 -->
      <div class="partition" v-if="adList.length">
        <img v-for="(item, i) in adList" :key="i" :src="item.bannerCover" alt="" @click="toAdDetail(item)" />
      </div>
      <!-- 非试用 -->
      <div v-if="isTrial == 0">
        <!-- 公开课 -->
        <div class="open_course" style="height: 2.67rem" v-if="recommendList.length !== 0">
          <div class="slide_discription">
            <div></div>
            <span>公开课</span>
            <a href="javascript:;" style="float: right; color: #76d18e; fontsize: 0.14rem; cursor: pointer" @click="openMore">更多</a>
          </div>
          <Row :gutter="17">
            <Col :span="4" v-for="(item, i) in recommendList" :key="i" class="create_activity gkCourse" @click.native="toCourseList(item)">
              <img :src="item.coursePicture" class="create_activity_pics" style="height: 100%; border-radius: 0.12rem" />
            </Col>
          </Row>
        </div>
        <!-- 创作活动 -->
        <div class="activity_square" v-if="activitiesList.length !== 0 && organizationId !== '-1'">
          <div class="slide_discription">
            <div class="slide_discription_l">
              <div class="border_l"></div>
              <p>创作活动</p>
              <Button type="primary" @click="toggleAll" :class="isShowAll ? 'shadow' : ''">全部</Button>
              <Button type="success" style="margin-left: 0.1rem" @click="toggleUnderway" :class="isShowUnderway ? 'shadow' : ''">进行中</Button>
              <Button class="btn_over" @click="toggleOver" :class="isShowOver ? 'shadow' : ''">已结束</Button>
            </div>
            <a href="javascript:; " @click="activityMore">更多</a>
          </div>
          <div class="acTest" style="" v-for="(item, i) in activitiesList" :key="i" @click="toActivityDetail(i)">
            <!-- 全部 -->
            <div class="acItem" v-if="isShowAll">
              <div class="create_activity">
                <div class="active_info">
                  <div class="active_num">
                    已参与<b>{{ item.planCount - item.surplusCount }}</b
                    >人
                  </div>
                </div>
                <img :src="item.cover" class="create_activity_pics" />
              </div>
              <div class="create_activity_info">
                <div class="acName">{{ item.name }}</div>
                <div class="acToos">
                  <span class="acTips" v-if="item.activitiesStatusValue == '进行中'">{{ item.activitiesStatusValue }}</span>
                  <span class="overClass" v-else>{{ item.activitiesStatusValue }}</span
                  ><Icon type="ios-time-outline" size="12" v-if="item.time !== ''" /><span class="asTime">{{ item.time }}</span>
                </div>
              </div>
              <div v-if="item.activitiesStatus === '2'" class="_icon"><img src="../../assets/to_submit.png" alt="" /></div>
            </div>
            <!-- 进行中 -->
            <div class="acItem" v-else-if="isShowUnderway && item.activitiesStatus !== '1'">
              <div class="create_activity">
                <div class="active_info">
                  <div class="active_num">
                    已参与<b>{{ item.planCount - item.surplusCount }}</b
                    >人
                  </div>
                </div>
                <img :src="item.cover" class="create_activity_pics" />
              </div>
              <div class="create_activity_info">
                <div class="acName">{{ item.name }}</div>
                <div class="acToos">
                  <span class="acTips" v-if="item.activitiesStatusValue == '进行中'">{{ item.activitiesStatusValue }}</span>
                  <span class="overClass" v-else>{{ item.activitiesStatusValue }}</span
                  ><Icon type="ios-time-outline" size="12" v-if="item.time !== ''" /><span class="asTime">{{ item.time }}</span>
                </div>
              </div>
              <div v-if="item.activitiesStatus === '2'" class="_icon"><img src="../../assets/to_submit.png" alt="" /></div>
            </div>
            <!-- 已结束 -->
            <div class="acItem" v-else-if="isShowOver && item.activitiesStatus === '1'">
              <div class="create_activity">
                <div class="active_info">
                  <div class="active_num">
                    已参与<b>{{ item.planCount - item.surplusCount }}</b
                    >人
                  </div>
                </div>
                <img :src="item.cover" class="create_activity_pics" />
              </div>
              <div class="create_activity_info">
                <div class="acName">{{ item.name }}</div>
                <div class="acToos">
                  <span :class="[{ acTips: true }, { overClass: overClass }]">{{ item.activitiesStatusValue }}</span
                  ><Icon type="ios-time-outline" size="12" v-if="item.time !== ''" /><span class="asTime">{{ item.time }}</span>
                </div>
              </div>
              <div v-if="item.activitiesStatus === '2'" class="_icon"><img src="../../assets/to_submit.png" alt="" /></div>
            </div>
          </div>
        </div>
        <!-- 同学动态 -->
        <div class="open_course" style="height: 4.5rem" v-if="classmateDynamicList.length !== 0">
          <div class="slide_discription">
            <div></div>
            <span>同学动态</span>
            <a href="javascript:;" style="float: right; color: #76d18e; fontsize: 0.14rem; cursor: pointer" @click="classmateMore">更多</a>
          </div>
          <Row :gutter="17">
            <Col :span="6" v-for="(item, i) in classmateDynamicList" :key="i">
              <div>
                <div class="classmate_info">
                  <img :src="item.studentAvatar" alt="" @click="toMyclassmate" />
                  <div class="cmInfo">
                    <p class="cmInfoSN">{{ item.studentName }}</p>
                    <p class="cmInfoCN" v-if="item.className">( {{ item.className }} )</p>
                    <p class="cmInfoCN" v-else></p>
                  </div>
                </div>
                <div class="classmateItem">
                  <div class="classmateItem_top" @click="toOpusDetails(item)">
                    <img :src="item.opusCover" alt="" class="create_activity_pics" style="width: 100%; height: 2rem" v-if="item.opusCover !== 'undefined' && item.opusCover" />
                    <img class="create_activity_pics" style="width: 100%; height: 2rem" src="../../assets/defaultCourseCover.png" alt="" v-else />
                  </div>
                  <div>
                    <p class="works_name">{{ item.opusName }}</p>
                    <Row class="tools">
                      <Col span="7">
                        <div class="look">
                          <span>{{ item.viewNumber ? item.viewNumber : '0' }}</span>
                        </div>
                      </Col>
                      <Col span="7">
                        <div :class="item.isPraised ? 'like' : 'disLike'">
                          <!-- <div :class="item.isPraised ? 'like' : 'disLike'" @click="toLike(item)"> -->
                          <span>{{ item.praiseNumber ? item.praiseNumber : '0' }}</span>
                        </div>
                      </Col>
                      <Col span="8">
                        <div :class="item.isCollectioned ? 'collect' : 'disCollect'">
                          <!-- <div :class="item.isCollectioned ? 'collect' : 'disCollect'" @click="toCollect(item)"> -->
                          <span>{{ item.collectionNumber ? item.collectionNumber : '0' }}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div v-else>
        <div class="studyCon">
          <!-- 我的课程 -->
          <div class="open_course myCorse" v-if="courseList.length !== 0">
            <div class="slide_discription">
              <div class="border_l"></div>
              <span>我的课程</span>
              <a href="javascript:;" style="float: right; color: #76d18e; fontsize: 0.18rem; cursor: pointer" @click="courseMore">更多</a>
            </div>
            <div class="create_activity">
              <div v-for="(item, i) in courseList" :key="i" @click="toCourseList(item)" class="cActivity">
                <img :src="item.coursePicture" />
              </div>
            </div>
          </div>
        </div>
        <!-- 视频 -->
        <div>
          <!-- 我的课程 -->
          <div class="open_course myCorse">
            <div class="slide_discription">
              <div class="border_l"></div>
              <span>视频资讯</span>
            </div>
            <div class="create_activity">
              <div class="cActivity" style="height: 2rem">
                <video
                  controls="controls"
                  style="width: 2.55rem"
                  poster="https://dy-static.oss-cn-beijing.aliyuncs.com/other/1.png"
                  src="https://dy-static.oss-cn-beijing.aliyuncs.com/other/%E5%85%B1%E9%9D%92%E5%9B%A2%E6%98%8E%E6%98%9F%E8%AF%B4%E7%BC%96%E7%A8%8B.mp4"
                ></video>
                <div>共青团和明星一起说编程</div>
              </div>
              <div class="cActivity" style="height: 2rem">
                <video
                  controls="controls"
                  style="width: 2.55rem"
                  poster="https://dy-static.oss-cn-beijing.aliyuncs.com/other/2.png"
                  src="https://dy-static.oss-cn-beijing.aliyuncs.com/other/%E7%BC%96%E7%A8%8B%E5%B0%8F%E6%98%8E%E6%98%9F.mp4"
                ></video>
                <div>那些编程小明星们</div>
              </div>
              <div class="cActivity" style="height: 2rem">
                <video
                  controls="controls"
                  style="width: 2.55rem"
                  poster="https://dy-static.oss-cn-beijing.aliyuncs.com/other/3.png"
                  src="https://dy-static.oss-cn-beijing.aliyuncs.com/other/%E5%90%84%E5%9C%B0%E7%BC%96%E7%A8%8B%E6%94%BF%E7%AD%96.mp4"
                ></video>
                <div>全国各地普及编程教育</div>
              </div>
              <div class="cActivity" style="height: 2rem">
                <video
                  controls="controls"
                  style="width: 2.55rem"
                  poster="https://dy-static.oss-cn-beijing.aliyuncs.com/other/4.jpg"
                  src="https://dy-static.oss-cn-beijing.aliyuncs.com/other/%E4%B8%96%E7%95%8C%E6%9C%BA%E5%99%A8%E4%BA%BA%E5%A4%A7%E8%B5%9B%202020%20%E4%BD%9B%E5%B1%B1%20%E5%9B%9E%E9%A1%BE%E7%89%87%E7%BB%88%E7%89%88_%E8%B6%85%E6%B8%85.mp4"
                ></video>
                <div>赛事集锦</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 文章 -->
        <div>
          <div class="open_course myCorse">
            <div class="slide_discription">
              <div class="border_l"></div>
              <span>最新动态</span>
            </div>
            <Row>
              <Col :span="24" v-for="(item, i) in newStarList" :key="i" class="reference_item" @click.native="toArtical(item, i)">
                <div class="refer" :gutter="42">
                  <div class="refer_l"><img :src="item.cover" class="refer_img" style="width: 2.62rem" /></div>
                  <div class="refer_r">
                    <h3>
                      {{ item.title }}
                    </h3>
                    <p>{{ item.programNewStarAbstract }}</p>
                    <div class="time">
                      <div class="timeL">
                        <Avatar :src="item.userAvatar" v-if="item.userAvatar !== 'undefined'"></Avatar
                        ><Avatar v-else src="https://dy-static.oss-cn-beijing.aliyuncs.com/students/img/IMG_0485.JPG"></Avatar><span class="txt">{{ item.signature }}</span
                        ><i>{{ item.createTime }}</i>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Card class="myDynamic" dis-hover>
        <div class="myDynamicBorder">
          <div class="_boder"></div>
          <span
            >我的动态<i>({{ myDynamicListWeight.length }}条)</i></span
          >
        </div>
        <div class="myDynamicLine"></div>
        <!-- <div style="margin-top:.16rem"></div> -->
        <div v-if="myDynamicListWeight.length">
          <ul v-for="(item, i) in myDynamicListWeight" :key="i">
            <li class="dynamicItem" v-if="item.type === '1'">{{ item.title }}</li>
            <li class="dynamicItem" style="color: #76d18e" v-else-if="item.type === '2'" @click="showDynamicModal(item)">{{ item.title }}</li>
            <li class="dynamicItem" style="color: #999; cursor: pointer" v-else>
              <span class="aTest" @click="toDynamicDetail(item.linkUrl)">{{ item.title }}</span>
            </li>
          </ul>
          <!-- <div class="dynamicMore">查看更多</div> -->
        </div>
        <div v-else style="width: 100%; height: 100%; text-align: center; margin-top: 1rem; font-size: 0.14rem">暂无动态展示~</div>
      </Card>
      <!-- <Card class="myDynamic studentManual" dis-hover>
        <div class="myDynamicBorder">
          <div class="_boder"></div>
          <span>操作手册</span>
        </div>
        <div class="myDynamicLine"></div>
        <div style="margin-top:.2rem;display:flex;justify-content: space-between">
          <div class="studentManu" style="width:1.4rem;text-align:center;height:.3rem;line-height:.3rem">学生操作手册</div>
          <Button type="primary" @click="downLoadManual">查看</Button>
        </div>
      </Card> -->
    </div>

    <!-- 动态展示模态框 -->
    <Modal v-model="isShowDynamic" :title="dynamicInfo.title">
      {{ dynamicInfo.content }}
      <div slot="footer"></div>
    </Modal>

    <Modal v-model="editSwitchModal" width="750"  :styles="{ top: '100px' }" >
      <div style="padding: 20px">
        <p style="font-size: 30px">当AI遇见图形化~快来试一试新版AI图形化编辑器</p>
        <p style="font-size: 17px; color: #a6a4a4;margin-top: 5px;">源码熊新版AI图形化编辑器上线啦！快来体验更多功能、拓展、AI积木！</p>
        <div style="width: 95%; display: flex; gap: 5%; margin: 40px auto">
          <div
            :style="{
              flex: 1,
              textAlign: 'center',
              boxSizing: 'border-box',
              border: selectedEditor === 'traditional' ? '2px solid #1890ff' : '2px solid #e8e8e8',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: selectedEditor === 'traditional' ? '0 2px 8px rgba(24, 144, 255, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
            }"
            @click="selectEditor('traditional')"
          >
            <img src="https://dy-static.oss-cn-beijing.aliyuncs.com/ScreenShot_2.png" />
            <p
              :style="{
                height: '40px',
                lineHeight: '40px',
                fontSize: '15px',
                backgroundColor: selectedEditor === 'traditional' ? '#1890ff' : 'transparent',
                color: selectedEditor === 'traditional' ? '#fff' : '#000',
                margin: '0',
                transition: 'all 0.3s ease',
              }"
            >
              使用传统编辑器
            </p>
          </div>

            <div
            :style="{
              flex: 1,
              textAlign: 'center',
              boxSizing: 'border-box',
              border: selectedEditor === 'ai' ? '2px solid #1890ff' : '2px solid #e8e8e8',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: selectedEditor === 'ai' ? '0 2px 8px rgba(24, 144, 255, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
            }"
            @click="selectEditor('ai')"
          >
            <img src="https://dy-static.oss-cn-beijing.aliyuncs.com/ScreenShot_1.png" />
            <p
              :style="{
                height: '40px',
                lineHeight: '40px',
                fontSize: '15px',
                backgroundColor: selectedEditor === 'ai' ? '#1890ff' : 'transparent',
                color: selectedEditor === 'ai' ? '#fff' : '#000',
                margin: '0',
                transition: 'all 0.3s ease',
              }"
            >
              使用AI编辑器
            </p>
          </div>

        </div>
        <div style="width: 100%; text-align: center; margin-top: 20px">
          <Button type="primary"  size="large" shape="circle" style="width:150px" @click="toOther()">立即创作</Button>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 苹果描述模态框 -->
    <!-- <Modal v-model="isShowDescription" class="explain" width="400">
      <img src="../../assets/appleDes.png" style="width:4rem" />
      <div slot="footer"></div>
    </Modal> -->
    <div v-if="isShowDescription" class="explain">
      <img src="../../assets/appleDes.png" style="width: 4rem" />
      <div class="closeApple" @click="closeApple">×</div>
    </div>
    <!-- 雷达图模态框 -->
    <Modal v-model="isShowRadar" title="能力维度" class="radarAvilable">
      <div style="width: 500px; height: 500px; background-color: #76d18e">
        <img :src="imgUrl" alt="" style="height: 30%" />
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="isShowCourseDetail" title="课程计划详情">
      <ul class="course_details">
        <li>课程名称：{{ content.courseName }}</li>
        <li>课程详情：{{ content.courseDetailsName }}</li>
        <li>课程任务：{{ content.teachingTask }}</li>
        <li>课程目标：{{ content.teachingGoal }}</li>
        <li>
          参考资料：
          <span v-if="content.materialList && content.materialList.length > 0">
            <div v-for="(item, index) in content.materialList" :key="index">
              <video v-if="item.materialType == 2" class="img_video" controls :src="vedioUrl">您的浏览器不支持 video 标签。</video>
              <img class="img_video" :src="item.materialUrl" alt="" v-if="item.materialType == 1" />
            </div>
          </span>
          <span v-else>暂无参考资料~~~</span>
        </li>
      </ul>
    </Modal>
    <Modal v-model="isShowInput" :mask-closable="false" class="perfectInfoBox" :closable="isShowClose">
      <div class="out">
        <div class="outL"></div>
        <div class="outR">
          <div v-if="!isShowClose" class="text">{{ countButton }}后可关闭</div>
          <div class="titInfo">完善资料</div>
          <Form ref="formData" :model="formData" :label-width="90" :rules="dataFormValidate">
            <FormItem label="学籍号:" prop="parentsContactWay">
              <Input v-model="formData.parentsContactWay" autocomplete="off" placeholder="请输入你的学籍号" />
            </FormItem>
            <FormItem label="姓名:" prop="name">
              <Input v-model="formData.name" autocomplete="off" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="性别:" prop="sex">
              <Radio-group v-model="formData.sex">
                <Radio label="男" value="男"></Radio>
                <Radio label="女" value="女"></Radio>
              </Radio-group>
            </FormItem>
            <FormItem label="出生日期:" prop="birthDayStr">
              <select v-model="formData.year" class="selectDom">
                <option default>请选择年份</option>
                <option v-for="item in yearList" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
              <select v-model="formData.month" class="selectDom">
                <option default>请选择月份</option>
                <option v-for="item in monthList" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </FormItem>
          </Form>
          <Button type="primary" @click="sunmitPerfectInfo()" :loading="submitLoading">提交</Button>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="isShowNotic" class="perfectInfoBox">
      <Carousel arrow="never" autoplay :autoplay-speed="3000" style="width: 100%; height: 100%" v-if="noticItems.length">
        <Carousel-item v-for="(item, i) in noticItems" :key="i">
          <img :src="item.imageUrl" alt="" @click="toNoticDetail(item)" style="width: 100%; border-radius: 0.12rem; display: block; cursor: pointer" />
        </Carousel-item>
      </Carousel>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
// window.addEventListener('resize', () => {
//   window.history.go(0)
// })
import echarts from 'echarts'

import {
  getOpenCourse,
  getAppleTree,
  getMyCourseList,
  getActivitiesList,
  getClassmateDynamicList,
  getOpusCountTop,
  getMyAchievements,
  getMyDynamic,
  getAdListByType,
  toPraise,
  toCollection,
  getMyTeachingPlanDetail,
  getStudentsCourseList,
  getProgramNewStarList,
  getPlayURL,
  showScratchEventTracking,
} from '@/api/index'
import adPic from './components/adPic.vue'
import { getRequest, postRequest, getRequestData } from '@/libs/axios'
import { validateMobile } from '@/libs/validate'
export default {
  name: 'home',
  components: {
    adPic,
  },
  data() {
    const validateBirthDayStr = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入出生日期'))
      } else {
        callback()
      }
    }
    return {
      selectedEditor: 'traditional',
      editorUrl:'',
      editSwitchModal: false,
      isShowNotic: false,
      noticItems: [],
      index: null,
      isShowRadar: false,
      isShowCourseDetail: false,
      content: '',
      isTrial: 0,
      courseList: [],
      imgUrl: '',
      num: 0,
      adQuery: {
        pageNumber: 1,
        pageSize: 4,
      },
      // 获取小新星列表参数
      newStarQuery: {
        pageNumber: 1,
        pageSize: 4,
      },
      newStarList: [],
      adList: [],
      adYoukeList: [],
      isShowDescription: false,
      // 我的成就击败率
      pct: '0',
      currentIndex: 0,
      randarInfo: [],
      radarScore: [],
      dynamicInfo: {},
      isShowDynamic: false,
      myDynamicList: [],
      appleTreeList: [],
      recommendList: [],
      classmateDynamicList: [],
      activitiesList: [],
      myCourseList: [],
      organizationId: '',
      // 排行榜
      ranking_idx: 1,
      // 排名数组
      rankingArr: [],
      newCourseList: [],
      // 排行榜
      topName: '',
      countTopList: [],
      // 我的成就
      myAchievements: {},
      placeArr: [
        [1.25, 1.2],
        [1.5, 1.5],
        [1, 1.5],
        [1, 0.9],
        [1.5, 0.9],
        [0.25, 1.2],
        [1, 0.6],
        [1.75, 0.9],
        [0.5, 1.5],
        [0.25, 1.8],
        [2.25, 1.5],
        [0.5, 0.9],
        [0.75, 1.2],
        [0.75, 1.8],
        [1.75, 1.2],
        [1.5, 1.8],
        [2.25, 1.8],
        [2, 1.5],
        [2.5, 1.7],
        [0.8, 0.8],
        [0.1, 1.6],
        [1.3, 0.7],
        [1.8, 1.6],
        [0.3, 1.6],
        [0.25, 1.2],
      ],
      // 制定雷达图配置项和数据
      option: {
        radar: {
          splitNumber: 5, // 雷达图圈数设置
          name: {
            textStyle: {
              color: '#fff',
              fontSize: '.12rem',
              padding: [-20, -20],
              // padding: [-2, -2],
            },
          },
          splitArea: {
            areaStyle: {
              color: 'transparent', // 圆环颜色
              // shadowColor: 'red', // 圆颜色?
              shadowBlur: 10,
            },
          },
          // 米字中间射线分割线
          axisLine: {
            lineStyle: {
              color: '#efefef',
            },
          },
          // 网格线
          splitLine: {
            lineStyle: {
              width: 1,
              color: '#fff',
            },
          },
          indicator: [],
          radius: 46, // radius代表缩放比
          center: ['50%', '50%'],
        },
        series: [
          {
            type: 'radar',
            symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
            symbolSize: 4, // 拐点的大小
            areaStyle: {
              color: '#fdaa02',
              offset: 1,
            },
            data: [
              {
                value: [1, 2, 3, 4, 5],
                name: '维度得分',
                // 设置区域边框和区域的颜色
                itemStyle: {
                  normal: {
                    color: '#c9c9c9',
                    lineStyle: {
                      color: '#c9c9c9',
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      isShowCourseRadar: false,
      radarMapList: [], // 雷达图项和值
      overClass: false,
      isShowAllBtn: true,
      isShowUnderway: false,
      isShowOver: false,
      isShowAll: true,
      vedioUrl: '',
      isShowInput: false,
      linkCardModelShow: false,
      formData: {
        sex: '男',
        birthDayStr: '',
        year: '2005',
        month: '01',
      },
      submitLoading: false,
      dataFormValidate: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur',
          },
        ],
        sex: [
          {
            required: true,
            message: '性别不能为空',
            trigger: 'blur',
          },
        ],
        // birthDayStr: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     validator: validateBirthDayStr
        //   },
        // ],
        parentsContactWay: [
          {
            required: true,
            message: '学籍号不能为空',
            trigger: 'blur',
          },
        ],
      },
      optionsDate: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now() - 86400000
        },
      },
      isShowClose: false,
      count: 10,
      countButton: '10秒',
      yearList: [
        { value: '1995', label: '1995' },
        { value: '1996', label: '1996' },
        { value: '1997', label: '1997' },
        { value: '1998', label: '1998' },
        { value: '1999', label: '1999' },
        { value: '2000', label: '2000' },
        { value: '2001', label: '2001' },
        { value: '2002', label: '2002' },
        { value: '2003', label: '2003' },
        { value: '2004', label: '2004' },
        { value: '2005', label: '2005' },
        { value: '2006', label: '2006' },
        { value: '2007', label: '2007' },
        { value: '2008', label: '2008' },
        { value: '2009', label: '2009' },
        { value: '2010', label: '2010' },
        { value: '2011', label: '2011' },
        { value: '2012', label: '2012' },
        { value: '2013', label: '2013' },
        { value: '2014', label: '2014' },
        { value: '2015', label: '2015' },
      ],
      monthList: [
        { value: '01', label: '1月' },
        { value: '02', label: '2月' },
        { value: '03', label: '3月' },
        { value: '04', label: '4月' },
        { value: '05', label: '5月' },
        { value: '06', label: '6月' },
        { value: '07', label: '7月' },
        { value: '08', label: '8月' },
        { value: '09', label: '9月' },
        { value: '10', label: '10月' },
        { value: '11', label: '11月' },
        { value: '12', label: '12月' },
      ],
      nickName: '',
    }
  },
  created() {
    this._getProgramNewStarList(this.newStarQuery)
    this.organizationId = this.$util.localGet('userInfo').organizationId
    this.isShowInput = false //!this.$util.localGet('userInfo').bindSchoolInfo
    // this.isShowInput = true
    this._getStudentsCourseList()
    this._getOpenCourse({ limit: 4 })
    this._getMyCourseList()
    this._getActivitiesList()
    this._getClassmateDynamicList()
    this._getOpusCountTop()
    this._getMyAchievements()
    this._getMyDynamic()
    this._getAppleTreeData() // 苹果树
    this._getNotic()
    this._getAdListByType({ category: 2 })
    this._getYoukeAdListByType({ category: 4 })
  },
  watch: {},
  computed: {
    activityList() {
      return this.sortByKey(this.activitiesList, 'surplusCount')
    },
    myDynamicListWeight() {
      return this.sortByKeyDown(this.myDynamicList, 'weight')
    },
    avatarPath() {
      return localStorage.avatorImgPath
    },
  },

  methods: {
    showScratchType(){
      this.editSwitchModal = true
    },
    toOther(){
      if(this.selectedEditor === 'traditional'){
        this.toPage("../peixun/showScratch");
      }else{
        this.toPage("https://ai-ide.xiongbangzhu.com");
      }
    },
    toPage(path){
      window.open(path, '_blank');
    },
    selectEditor(type){
      this.selectedEditor = type
    },
    tracking(event) {
      console.log(event)
      let params = {
        event,
      }
      showScratchEventTracking(params)
    },
    countDown() {
      let that = this
      if (this.count === 0) {
        this.count = 10
        return
      } else {
        this.countButton = this.count + '秒'
        this.count--
      }
      setTimeout(function () {
        that.countDown()
      }, 1000)
    },
    // 获取编程小新星列表
    async _getProgramNewStarList(obj) {
      const res = await getProgramNewStarList(obj)
      if (res.success !== true) return this.$Message.error(res.message)
      if (res.result && res.result.data.length) {
        res.result.data[0].viewNumber = 108 + res.result.data[0].viewNumber
        res.result.data[1].viewNumber = 118 + res.result.data[1].viewNumber
        res.result.data[2].viewNumber = 128 + res.result.data[2].viewNumber
        res.result.data[3].viewNumber = 108 + res.result.data[3].viewNumber
        this.newStarList = res.result.data
      }
    },
    // 进入文章详情
    toArtical(item, i) {
      let url = this.$router.resolve({
        name: 'artical-detail',
        query: {
          id: item.id,
        },
      })
      window.open(url.href) //注意，需要加href
      util.localSet('aticalViewnum', this.newStarList[i].viewNumber)
    },
    sunmitPerfectInfo() {
      if (this.formData.year && this.formData.month) {
        this.formData.birthDayStr = this.formData.year + '-' + this.formData.month + '-01'
      }
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const result = await postRequest('/v3/student/improvePersonalInformation ', this.formData, false)
          if (result.success) {
            this.$Message.success(result.message)
            this.isShowInput = false
            this.getStudentInfo()
          }
          this.submitLoading = false
        }
      })
      // let that = this
      // this.$refs.formData.validate(async function(valid){
      //   if (valid) {
      //     that.submitLoading = true;
      //     const result = await postRequest(
      //       "/v3/student/improvePersonalInformation ",
      //       that.formData,
      //       false
      //     );
      //     if (result.success) {
      //       that.$Message.success(result.message);
      //       that.isShowInput = false
      //       that.getStudentInfo()
      //     }
      //     that.submitLoading = false;
      //   }
      // })
    },
    async getStudentInfo() {
      const res = await getRequest('/v3/student/getStudentInfo', null, false)
      if (res.success) {
        this.$util.localSet('userInfo', res.result)
      }
    },
    imgLoad() {
      this.$nextTick(() => {
        this.height = this.$refs.bannerHeight[0].height + 'px'
      })
    },
    // 获取我的动态
    async _getMyDynamic() {
      const res = await getMyDynamic()
      this.myDynamicList = res.result
    },
    courseMore() {
      this.$router.push({
        name: 'tb-myCoursePage',
      })
    },
    // 当动态消息为展示消息时
    showDynamicModal(params) {
      this.dynamicInfo = params
      this.isShowDynamic = true
    },
    showDescription() {
      this.isShowDescription = true
    },
    // 苹果树
    async _getAppleTreeData() {
      const res = await getAppleTree()
      if (res.result !== null) {
        this.appleTreeList = res.result
      }
      this._initAppleTree(0)
    },

    // 苹果树
    async _getNoticData() {
      const res = await getRequestData('https://dy-static.oss-cn-beijing.aliyuncs.com/notice/noticstu.json')
      if (res.result !== null) {
        const now = new Date()
        this.noticItems = []
        res.result.forEach((event) => {
          const startTime = new Date(event.startTime)
          const endTime = new Date(event.endTime)
          console.log(startTime, endTime)
          if (now >= startTime && now <= endTime) {
            this.noticItems.push(event)
          }
        })
        if (this.noticItems.length) {
          this.isShowNotic = true
        }
      }
    },
    async toNoticDetail(item) {
      if (item.redirectUrlStatus == 1) {
        this.isShowNotic = false
        window.open(item.redirectUrl)
      }
      if (item.displayDuration == 1) {
        //发生关闭请求
        const res = await getRequest(`/v3/notice/closeNotice?id=${item.id}`, null, false)
      }
    },
    // 获取通知数据
    async _getNotic() {
      const res = await getRequest('/v3/notice/getMyNoticeList', null, false)
      if (res.result !== null) {
        res.result.forEach((item) => {
          if (item.displayMode == 1) {
            //（1：弹窗提醒 2：侧边提示）
            this.noticItems.push(item)
          }
        })
        if (this.noticItems.length) {
          this.isShowNotic = true
        }
      }
    },
    // 苹果树
    async _initAppleTree(index) {
      // 雷达图
      if (this.appleTreeList && this.appleTreeList.length) {
        // 小苹果
        var tree = this.$refs.tree
        var allApple = document.getElementsByClassName('removeApple')
        var apple
        var cloneApple
        if (allApple.length > 0) {
          for (let i = allApple.length - 1; i >= 0; i--) {
            tree.removeChild(allApple[i])
          }
        }
        if (!this.appleTreeList[index] || !this.appleTreeList[index].nodeList) return
        this.appleTreeList[index].nodeList.forEach((item, i) => {
          // 增加百分制得分大于5采取百分制 <60为1号苹果 60-70为2号苹果 以此类推。。。
          if (item > 5) {
            // 分值大于5 熊帮主没有维度 隐藏维度
            this.isShowCourseRadar = false
          } else {
            this.isShowCourseRadar = true
          }
          if ((item <= 60 && item > 5) || item === 1) {
            apple = this.$refs.apple1
          } else if ((item > 60 && item <= 70) || item === 2) {
            apple = this.$refs.apple2
          } else if ((item > 70 && item <= 80) || item === 3) {
            apple = this.$refs.apple4
          } else if ((item > 80 && item <= 90) || item === 4) {
            apple = this.$refs.apple3
          } else {
            apple = this.$refs.apple5
          }
          cloneApple = apple.cloneNode()
          cloneApple.className = 'removeApple'
          cloneApple.style.opacity = '1'
          cloneApple.style.width = apple.width / 100 + 'rem'
          cloneApple.style.height = apple.height / 100 + 'rem'
          if (this.placeArr[i]) {
            cloneApple.style.left = this.placeArr[i][0] + 'rem'
            cloneApple.style.top = this.placeArr[i][1] + 'rem'
          }

          tree.appendChild(cloneApple)
        })
        setTimeout(() => {
          if (this.appleTreeList[index].radarMap && this.appleTreeList[index].radarMap.length) {
            let result = this.appleTreeList[index].radarMap
            this.radarMapList = result
            this.option.radar.splitNumber = this.radarMapList.length
            let indicator = []
            let dataValue = []
            result.forEach((item) => {
              indicator.push({ name: item.text, max: 5 })
              dataValue.push(item.value)
            })
            this.option.radar.indicator = indicator
            this._splitNumber = indicator.length
            this.option.series[0].data[0].value = dataValue
            var myChart = echarts.init(document.getElementById('container'))
            myChart.setOption(this.option, true)
            this.imgUrl = myChart.getDataURL()
          }
        }, 500)
      }
    },
    // 点击小树切换雷达图和数据 进入页面默认显示第一棵树信息，点击小树切换信息
    toggleTree(i) {
      this.index = i
      this._initAppleTree(i)
    },
    // 千转k  万转w
    numConvert(num) {
      if (num >= 10000) {
        num = Math.round(num / 1000) / 10 + 'W'
      } else if (num >= 1000) {
        num = Math.round(num / 100) / 10 + 'K'
      }
      return num
    },
    // 获取排行榜信息
    async _getOpusCountTop() {
      const res = await getOpusCountTop()
      if (res.success) {
        // this.countTopList = res.result
        res.result.content.forEach((item) => {
          item.opusCount = this.numConvert(item.opusCount)
        })
        this.countTopList.push(res.result)
        this.countTopList.forEach((item) => {
          return this.sortByKey(item.content, 'ranking')
        })
      }
    },
    // 排序(up)
    sortByKey(array, key) {
      // (排行榜、创作活动热度升序 )
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    sortByKeyDown(array, key) {
      // (我的动态按权重的降序排列)
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        // return x < y ? -1 : x > y ? 1 : 0
        return x > y ? -1 : x < y ? 1 : 0
      })
    },
    // 我的成就
    async _getMyAchievements() {
      const res = await getMyAchievements()
      if (res.success) {
        this.myAchievements = res.result
        this.pct = (this.myAchievements.beatProportion * 100).toFixed(2)
      }
    },
    toMyOpusPage() {
      this.$router.push({
        name: 'tb-myOpus',
      })
    },
    // 获取我的课程
    async _getStudentsCourseList() {
      const res = await getStudentsCourseList()
      if (!res.success) return this.$Message.error(res.message)
      this.courseList = res.result
    },
    // 获取我的课程
    async _getMyCourseList() {
      const res = await getMyCourseList()
      if (res.success) {
        this.myCourseList = res.result
        for (var i = 0; i < this.myCourseList.length; i += 2) {
          this.newCourseList.push(this.myCourseList.slice(i, i + 2))
        }
      }
    },
    // 我的课程计划详情
    toLastCourseDetail(item) {
      if (!item.lastCourseTeachingPlan || !item.lastCourseTeachingPlan.courseDetailId) return
      let parmse = {
        courseDetailsId: item.lastCourseTeachingPlan.courseDetailId,
      }
      if (item.lastCourseTeachingPlan.courseRecordId) {
        parmse.courseRecordId = item.lastCourseTeachingPlan.courseRecordId || ''
      }
      this.getMdText(parmse)
    },
    toNextCourseDetail(item) {
      if (!item.nextCourseTeachingPlan || !item.nextCourseTeachingPlan.courseDetailId) return
      let parmse = {
        courseDetailsId: item.nextCourseTeachingPlan.courseDetailId,
      }
      if (item.nextCourseTeachingPlan.courseRecordId) {
        parmse.courseRecordId = item.nextCourseTeachingPlan.courseRecordId || ''
      }
      this.getMdText(parmse)
    },
    // 获取课程计划详情
    async getMdText(parmse) {
      const res = await getMyTeachingPlanDetail(parmse)
      if (res.result.materialList && res.result.materialList.length) {
        let vid = res.result.materialList[0].materialUrl
        const restow = await getRequest(`/v1/user/getPlayURL/${vid}`, null, true)
        if (restow.success) {
          this.vedioUrl = restow.result[0]
        }
      }
      this.content = res.result
      this.isShowCourseDetail = true
    },
    // 获取广告位信息
    async _getAdListByType(obj) {
      const res = await getAdListByType(obj)
      if (!res.success) return this.$Message.error(res.message)
      this.adList = res.result
      // this.adQuery = res.result
    },
    async _getYoukeAdListByType(obj) {
      const res = await getAdListByType(obj)
      if (!res.success) return this.$Message.error(res.message)
      this.adYoukeList = res.result
    },
    toAdDetail(item) {
      if (item.adLink) {
        window.open(item.adLink)
      }
    },
    // 获取公开课信息
    async _getOpenCourse(obj) {
      const res = await getOpenCourse(obj)
      if (!res.success) return this.$Message.error(res.message)
      this.recommendList = res.result
    },
    // 课程列表
    toCourseList(item) {
      this.$router.push({
        name: 'tb-courseList',
        query: {
          id: item.id,
          courseDescription: item.courseDescription,
          coursePicture: item.coursePicture,
        },
      })
    },
    // 不足两位前补零
    formate(time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    },
    // 创作活动
    async _getActivitiesList() {
      const res = await getActivitiesList()
      if (res.success !== true) return this.$Message.error(res.message)
      if (res.result !== null) {
        if (res.result.length) {
          this.activitiesList = res.result
          this.activitiesList.forEach((item) => {
            const endTime = new Date(item.endTime)
            const startTime = new Date(item.startTime)
            const currentTime = new Date()

            // 活动没开始
            if (startTime.getTime() > currentTime.getTime()) {
              let timeNone = startTime.getTime() - currentTime.getTime()
              let timeDate = parseInt(timeNone / 1000)
              let d = parseInt(timeDate / (24 * 60 * 60))
              let h = this.formate(parseInt((timeDate / (60 * 60)) % 24))
              let m = this.formate(parseInt((timeDate / 60) % 60))
              item.time = `距离开始：${d}天${h}小时${m}分`
              item.activitiesStatusValue = '进行中'
            } else {
              let timeDiffer = endTime.getTime() - currentTime.getTime()
              if (timeDiffer > 0) {
                let timeDate = parseInt(timeDiffer / 1000)
                let d = parseInt(timeDate / (24 * 60 * 60))
                let h = this.formate(parseInt((timeDate / (60 * 60)) % 24))
                let m = this.formate(parseInt((timeDate / 60) % 60))
                item.time = `倒计时：${d}天${h}小时${m}分`
                item.activitiesStatusValue = '进行中'
                this.overClass = false
              } else {
                item.time = ''
                item.activitiesStatusValue = '评审中...'
              }
              if (item.activitiesStatus === '1') {
                item.time = '活动已截止'
                item.activitiesStatusValue = '已结束'
                this.overClass = true
              }
            }
          })
        }
      }
    },
    // 点击按钮切换进行中或已结束的活动
    toggleAll() {
      this.isShowUnderway = false
      this.isShowOver = false
      this.isShowAll = true
    },
    toggleUnderway() {
      this.isShowUnderway = true
      this.isShowOver = false
      this.isShowAll = false
    },
    toggleOver() {
      this.isShowOver = true
      this.isShowUnderway = false
      this.isShowAll = false
    },
    toActivityDetail(i) {
      // 点击的活动id
      let id = this.activitiesList[i].id
      let activitiesStatus = this.activitiesList[i].activitiesStatus
      this.$router.push(`/activityDetail?id=${id}&activitiesStatus=${activitiesStatus}`)
    },
    // 同学动态
    async _getClassmateDynamicList() {
      const res = await getClassmateDynamicList({ limit: 4 })
      if (!res.success) return this.$Message.error('获取数据失败')
      if (res.result !== null) {
        res.result.forEach((item) => {
          item.viewNumber = this.numConvert(item.viewNumber)
          item.praiseNumber = this.numConvert(item.praiseNumber)
          item.collectionNumber = this.numConvert(item.collectionNumber)
        })
        this.classmateDynamicList = res.result
      }
    },
    toOpusDetail(url) {
      url = url.substr(8)
      this.$router.push(url)
    },
    // 点赞
    toLike(item) {
      this._toPraise(item)
    },
    async _toPraise(obj) {
      const res = await toPraise(obj.opusId)
      if (!res.success) return this.$Message.error('点赞失败')
      this.$Message.success('点赞成功')
      obj.praiseNumber = obj.praiseNumber + 1
      obj.isPraised = true
      // setTimeout(() => {
      //   this._getClassmateDynamicList()
      // }, 2000)
    },
    // 收藏
    toCollect(item) {
      this._toCollect(item)
    },
    async _toCollect(obj) {
      const res = await toCollection(obj.opusId)
      if (!res.success) return this.$Message.error('收藏失败')
      this.$Message.success('收藏成功')
      obj.collectionNumber = obj.collectionNumber + 1
      obj.isCollectioned = true
      // setTimeout(() => {
      //   this._getClassmateDynamicList()
      // }, 2000)
    },
    goPython() {
      this.$router.push('../peixun/showPython')
    },
    // 点击头像进入我的同学
    toMyclassmate() {
      this.$router.push('/student/myClassmate')
    },
    //
    openMore() {
      this.$router.push('/student/openCoursePage')
    },
    activityMore() {
      this.$router.push('/student/activityPage')
    },
    classmateMore() {
      this.$router.push('/student/classmateDynamicPage')
    },
    // 从同学动态到作品详情
    toOpusDetails(item) {
      const { opusType, opusId, studentId, isActivityOpus = false } = item
      if (opusType == 2) {
        this.$router.push(`/opusDetail?id=${item.opusId}&isOpend=''&opusPath=''`)
      }
      if (opusType == 3) {
        let routeUrl = this.$router.resolve({
          path: '../peixun/showPython',
          query: { opusId, studentId, isActivityOpus },
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    // 查看雷达图详情
    toViewRadar() {
      this.isShowRadar = true
    },
    toDynamicDetail(url) {
      url = url.substr(8)
      this.$router.push(url)
    },
    downLoadManual() {
      let url = 'https://dy-static.oss-cn-beijing.aliyuncs.com/students/doc/%E6%BA%90%E7%A0%81%E7%86%8A%E5%AD%A6%E7%94%9F%E7%AB%AF%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf'
      window.open(url, '_blank')
    },
    // 关闭苹果说明
    closeApple() {
      this.isShowDescription = false
    },
  },
  filters: {
    proName(value) {
      if (value.length <= 4) return value
      let str = value.substring(0, 4)
      str += '...'
      return str
    },
    userName(value) {
      if (value.length <= 3) return value
      let str = value.substring(0, 3)
      str += '...'
      return str
    },
    // 解密视频
    async handleVCODEvideo(value) {
      let res = await getPlayURL(value)
      if (res.success) {
        return res.result[0]
      } else {
        return ''
      }
    },
  },
  mounted() {
    if (this.$util.localGet('studentStatus') == 1) {
      this.isTrial = 1
    }
    setTimeout(() => {
      this.isShowClose = true
    }, 10000)
    this.countDown()
    var that = this
    that.$nextTick(() => {
      that.height = document.body.clientHeight / 3 + 'px'
    })
    window.onload = () => {
      that.height = document.body.clientHeight / 3 + 'px'
    }
  },
}
</script>
<style lang="less" scoped>
@import './home.less';
// @import '../student/style/opusSquare.less';

.studyCon {
  width: 100%;
}
.open_course {
  position: relative;
  width: 100%;
  min-height: 2.46rem;
  padding: 0.2rem 0.3rem;
  background-color: #fff;
  border-radius: 0.12rem;
  overflow: hidden;
  margin: 0.3rem 0;
  .slide_discription {
    width: 100%;
    height: 0.18rem;
    line-height: 0.18rem;
    margin-bottom: 0.2rem;
    .border_l {
      float: left;
      width: 0.06rem;
      height: 100%;
      border-radius: 0.03rem;
      background-color: #76d18e;
    }
    span {
      margin-left: 0.14rem;
      font-family: 'PingFang-SC-Medium';
      color: #222;
      font-size: 0.18rem;
    }
    a {
      color: #666;
      font-size: 0.18rem;
    }
    .active {
      color: #76d18e !important;
      background-color: transparent !important;
    }
  }
  // .ivu-row {
  margin-top: 0.2rem;
  .create_activity {
    position: relative;
    margin-bottom: 0.3rem;
    width: 30%;
    // height: 1.65rem;
    .cActivity {
      overflow: hidden;
      width: 2.55rem;
      // float: left;
      display: inline-block;
      margin: 0 0.14rem 0.2rem 0;
      height: 1.65rem;
      border-radius: 0.12rem;
      img {
        width: 2.55rem;
        height: 100%;
        border-radius: 0.12rem;
        transition: 0.6s;
        cursor: pointer;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    .cActivity:nth-child(5n) {
      margin-right: 0;
    }
  }
  .reference_item {
    border-radius: 0.12rem;
    padding: 0.1rem;
    cursor: pointer;
    padding-right: 0;
    .refer {
      display: flex;
      height: 2rem;
      padding-top: 0.2rem;
      border-top: 0.01rem solid #ccc;
      cursor: pointer;
      .refer_l {
        float: left;
        width: 2.67rem;
        height: 1.7rem;
        margin-right: 0.4rem;
        border-radius: 0.12rem;
        overflow: hidden;
        .refer_img {
          width: 100%;
          height: 100%;
          transition: 0.6s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
      .refer_r {
        width: 77%;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        h3 {
          max-width: 6rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          color: #333;
          font-size: 0.18rem;
          margin-top: 0.08rem;
          font-weight: 400;
        }
        p {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          margin: 0.1rem 0 0.2rem;
          width: 7.68rem;
          font-size: 0.14rem !important;
          font-family: 'PingFang SC';
          color: #999;
          line-height: 0.3rem;
        }
        .time {
          width: 100%;
          height: 0.31rem;
          align-items: center;
          display: inline-flex;
          justify-content: space-between;
          color: #76d18e;
          font-size: 0.12rem;
          .timeL {
            display: inline-flex;
            align-items: center;
          }
          .txt {
            margin-left: 0.15rem;
          }
          /deep/ .ivu-avatar > img {
            border-radius: 50%;
            border: 0.01rem solid rgba(245, 134, 6, 0.5);
          }
          i {
            font-style: normal;
            margin-left: 0.15rem;
          }
          .time_r {
            height: 0.4rem;
            border: 0.01rem solid transparent;
            border-radius: 0.1rem;
            padding: 0 0.12rem;
            display: inline-flex;
            justify-content: space-around;
            align-items: center;
            color: #666;
          }
          .time_r:hover {
            border: 0.01rem solid #ccc;
          }
        }
      }
    }
  }
  // }
  .freeBtn {
    margin-top: 0.31rem;
    width: 100%;
    height: 0.48rem;
    background: #e2e2e2;
    // opacity: 0.1;
    border-radius: 0.1rem;
    border: none;
    box-shadow: none;
    /deep/ span {
      position: relative;
      color: #333;
      font-size: 0.18rem;
    }
  }
}
.explain {
  position: absolute;
  left: 30%;
  top: 1rem;
  .closeApple {
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    color: #fff;
    font-size: 0.3rem;
    cursor: pointer;
  }
}
.explain /deep/ .ivu-modal-content {
  background-color: transparent;
  box-shadow: none;
}
.explain /deep/ .ivu-modal-body {
  padding: 0;
}
.removeApple {
  position: absolute;
}
.tips {
  width: 100%;
  text-align: center;
  color: #999;
  height: 1.6rem;
  line-height: 1.6rem;
}
.course_details {
  li {
    list-style: none;
    margin-bottom: 10px;
    .img_video {
      width: auto;
      height: 120px;
    }
  }
}
.selectDom {
  width: 1rem;
  border: 0.01rem solid #dcdee2;
  border-radius: 0.04rem;
  color: #515a6e;
  height: 0.32rem;
}
.selectDom1 {
  width: 100%;
  border: 0.01rem solid #dcdee2;
  border-radius: 0.04rem;
  color: #515a6e;
  height: 0.32rem;
}
.selectDom:focus {
  outline: none;
}
.scratch {
  position: absolute !important;
  top: 0.32rem !important;
  left: 1.1rem !important;
  font-size: 0.28rem !important;
  font-weight: 700 !important;
  color: #ffffff !important;
}
.python {
  font-size: 0.28rem !important;
  left: 0.3rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue